import { Form } from 'antd';
import { Product } from '../../../../lib/Product';

export function useIsExceptional() {
  const form = Form.useFormInstance();
  return Form.useWatch(Product.IS_EXCEPTIONAL, form);
}
